import { Controller } from "stimulus"

// 追加請求モーダル（YAS-14 FR-1）。
// - モーダルの開閉
// - 請求項目名のプリセット/自由入力切替
// - 送信ボタンの二重送信防止（disabled 化）
export default class extends Controller {
  static targets = ["modal", "itemNamePreset", "itemNameCustom", "submit", "form"]

  open() {
    this.modalTarget.classList.add("is-active")
  }

  close() {
    this.modalTarget.classList.remove("is-active")
  }

  // プリセット選択で "custom" のときのみ自由入力欄を表示
  toggleItemName() {
    if (!this.hasItemNameCustomTarget) return
    const isCustom = this.itemNamePresetTarget.value === "custom"
    this.itemNameCustomTarget.classList.toggle("is-hidden", !isCustom)
    const input = this.itemNameCustomTarget.querySelector("input")
    if (input) input.disabled = !isCustom
  }

  // 二重送信防止: 送信時にボタンを無効化
  onSubmit() {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true
      this.submitTarget.classList.add("is-loading")
    }
  }
}
